import { styled } from '@mui/system'
import { Grid as GridBase } from '@mui/material'

export const Container = styled(GridBase)(() => ({}))

export const Grid = styled(GridBase)(() => ({
  pointerEvents: 'none',
}))
